import React from "react";
import styles from "../InverluxApps.module.css";

const ChromeWebStoreButton = () => (
  <a
    className={styles.storeButton}
    href="https://chromewebstore.google.com/detail/collapse-all-for-gmail/ciiegimfdhalfdhfpiennhaoajbpcfjp"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Add Collapse All for Gmail to Chrome"
  >
    <span className={styles.storeButtonIcon} aria-hidden="true">
      ↗
    </span>
    <span>
      <span className={styles.storeButtonLabel}>Add to Chrome</span>
      <span className={styles.storeButtonStatus}>Chrome Web Store</span>
    </span>
  </a>
);

export default ChromeWebStoreButton;
